import React from "react";

const COURTS = [
  {
    label: "District & subordinate courts",
    value: "4.76 crore",
    color: "#1E3270",
  },
  { label: "25 High Courts", value: "63.66 lakh", color: "#F2A33A" },
  { label: "Supreme Court of India", value: "92,101", color: "#B4690E" },
];

// 100 squares: 88 district, 11 High Court, 1 Supreme Court
const cells = Array.from({ length: 100 }, (_, i) =>
  i < 88 ? "" : i < 99 ? "is-hc" : "is-sc",
);

const Landscape = () => (
  <section id="landscape" className="vd-section">
    <div className="container">
      <div className="row g-5 align-items-center">
        <div className="col-lg-6">
          <span className="vd-eyebrow">WHY NOW</span>
          <h2 className="vd-h2">
            Over 5.4 crore cases are pending in Indian courts.
          </h2>
          <p className="vd-lead mb-4">
            Every pending matter carries hearings to track, orders to read and
            replies to file. Practices that keep up are the ones that stop doing
            the repetitive work by hand.
          </p>
          {COURTS.map((c) => (
            <div className="vd-stat-row" key={c.label}>
              <span className="d-flex align-items-center gap-2">
                <span className="vd-dot" style={{ background: c.color }} />
                {c.label}
              </span>
              <strong>{c.value}</strong>
            </div>
          ))}
          <p className="vd-small-note">
            Source: Ministry of Law &amp; Justice, written reply in the Lok
            Sabha, 13 Feb 2026 (NJDG data as of 31 Dec 2025).
          </p>
        </div>

        <div className="col-lg-6">
          <figure className="vd-figure">
            <figcaption className="mb-3">
              <div className="vd-figure__title">Where the backlog sits</div>
              <div className="vd-figure__sub mb-0">
                Each square ≈ 1% of all pending cases (≈ 5.4 lakh cases)
              </div>
            </figcaption>
            <div
              className="vd-waffle"
              role="img"
              aria-label="88 percent of pending cases are in district courts, about 12 percent in High Courts, and under 0.2 percent in the Supreme Court"
            >
              {cells.map((c, i) => (
                <span key={i} className={c} />
              ))}
            </div>
            <div className="row g-3 text-center">
              <div className="col-4">
                <div className="vd-waffle-key">
                  88%<small>District courts</small>
                </div>
              </div>
              <div className="col-4">
                <div className="vd-waffle-key">
                  12%<small>High Courts</small>
                </div>
              </div>
              <div className="col-4">
                <div className="vd-waffle-key">
                  0.17%
                  <small>
                    Supreme Court — the small mark in the last square
                  </small>
                </div>
              </div>
            </div>
          </figure>
        </div>
      </div>
    </div>
  </section>
);

export default Landscape;
